import Container from '@mui/material/Container';

import { paths } from 'src/routes/paths';

import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';

import IssuedChequeNewEditForm from '../issued-cheque-new-edit-form';

export default function IssuedChequeCreateView() {
  const settings = useSettingsContext();

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <CustomBreadcrumbs
        heading="Enter an issued cheque"
        links={[
          { name: 'Issued Cheques', href: paths.dashboard.issuedCheque.root },
          { name: 'New' },
        ]}
        sx={{ mb: { xs: 3, md: 5 } }}
      />

      <IssuedChequeNewEditForm />
    </Container>
  );
}
